module.exports = __webpack_public_path__ + "img/supplier_2.d4dc7943.webp";